<template>
    <v-app class="theme--dark black">
        <router-view></router-view>
    </v-app>
</template>

<script>
    import Vue from 'vue'

    export default Vue.extend({
        name: 'App'
    })
</script>

<style lang="scss">
    :root {
        --gold: radial-gradient(ellipse farthest-corner at right bottom, #FEDB37 0%, #FDB931 8%, #9f7928 30%, #8A6E2F 40%, transparent 80%),
        radial-gradient(ellipse farthest-corner at left top, #FFFFFF 0%, #FFFFAC 8%, #D1B464 25%, #5d4a1f 62.5%, #5d4a1f 100%) !important;

        --gold-gradient: radial-gradient(ellipse farthest-corner at right bottom, #FEDB37 0%, #FDB931 0%, #9f7928 30%, #8A6E2F 40%, transparent 80%),
        radial-gradient(ellipse farthest-corner at left top, #FFFFFF 0%, #FFFFAC 0%, #D1B464 25%, #5d4a1f 62.5%, #5d4a1f 100%) !important;
    }

    .row {
        font-size: 18px !important;
        font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
    }

    a {
        text-decoration: none;
        color: white;
    }

    .btn-gold {
        background: var(--gold-gradient);
    }

    .btn-overlay {
        z-index: 2;
        position: fixed;
        top: 50vh;
        bottom: 50vh;
        left: 0;
    }

    .nav-link {
        text-decoration: none;
        margin: 0 10px;
        color: white;

        &:hover {
            color: #ffd700;
            border-bottom: 1px solid #ffd700;
        }

        .v-icon {
            color: white;

            &:hover {
                color: #ffd700;
                border-bottom: none;
            }
        }

    }

</style>
